import { render } from "./FormPanel.vue?vue&type=template&id=6a2e1d57&scoped=true"
import script from "./FormPanel.vue?vue&type=script&lang=ts"
export * from "./FormPanel.vue?vue&type=script&lang=ts"

import "./FormPanel.vue?vue&type=style&index=0&id=6a2e1d57&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6a2e1d57"

export default script